module.exports = __webpack_public_path__ + "img/error.0774518d.jpg";